import { render, staticRenderFns } from "./StatsCard.vue?vue&type=template&id=262b2bb3&scoped=true&lang=pug"
import script from "./StatsCard.vue?vue&type=script&lang=ts"
export * from "./StatsCard.vue?vue&type=script&lang=ts"
import style0 from "./StatsCard.vue?vue&type=style&index=0&id=262b2bb3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262b2bb3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VIcon,VSheet,VSkeletonLoader})
